import { render, staticRenderFns } from "./OfisTercihlerView.vue?vue&type=template&id=e39db26c"
import script from "./OfisTercihlerView.vue?vue&type=script&lang=ts"
export * from "./OfisTercihlerView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports